 <app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1>{{ 'ToilOccurrenceReport' | translate: {Default: "Toil Occurrence Report"} }}</h1>
    </mat-toolbar>

    <div class="content">
        <app-toil-occurrence-details-data-grid></app-toil-occurrence-details-data-grid>
    </div>
</app-layout>
